// Font Configuration
// Easy font switching - just change the CURRENT_FONT variable below

// Available font options
const FONT_OPTIONS = {
  // 🔥 MODERN & CLEAN FONTS
  DM_SANS: '"DM Sans"',
  INTER: '"Inter"',
  MANROPE: '"Manrope"',
  PLUS_JAKARTA: '"Plus Jakarta Sans"',

  // 🎨 POPULAR & VERSATILE FONTS
  POPPINS: '"Poppins"',
  NUNITO: '"Nunito"',
  LATO: '"Lato"',

  // 📚 CLASSIC & RELIABLE FONTS
  ROBOTO: '"Roboto"',
  OPEN_SANS: '"Open Sans"',
  SOURCE_SANS: '"Source Sans 3"',

  // 🖥️ SYSTEM DEFAULT
  SYSTEM: 'system-ui'
};


// 🎯 CHANGE THIS TO SWITCH FONTS GLOBALLY
// Options: DM_SANS, INTER, MANROPE, PLUS_JAKARTA, POPPINS, NUNITO, LATO, ROBOTO, OPEN_SANS, SOURCE_SANS, SYSTEM
export const CURRENT_FONT = FONT_OPTIONS.INTER;

// Font weight constants
export const FONT_WEIGHTS = {
  thin: 100,
  extraLight: 200,
  light: 300,
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
  extraBold: 800,
  black: 900
};

// Function to apply font to CSS variables
export const applyFontToCSSVariables = () => {
  const root = document.documentElement;
  root.style.setProperty('--primary-font-family', CURRENT_FONT);
};
